module.exports = __webpack_public_path__ + "img/ogn.5e4f6dc8.svg";